__turbopack_context__.v({
  "border": "TalesBlockTwoImage-module-scss-module__F3OwdG__border",
  "caption": "TalesBlockTwoImage-module-scss-module__F3OwdG__caption",
  "fade-in": "TalesBlockTwoImage-module-scss-module__F3OwdG__fade-in",
  "image": "TalesBlockTwoImage-module-scss-module__F3OwdG__image",
  "inner": "TalesBlockTwoImage-module-scss-module__F3OwdG__inner",
  "isInView": "TalesBlockTwoImage-module-scss-module__F3OwdG__isInView",
  "media": "TalesBlockTwoImage-module-scss-module__F3OwdG__media",
  "mediaItem": "TalesBlockTwoImage-module-scss-module__F3OwdG__mediaItem",
  "root": "TalesBlockTwoImage-module-scss-module__F3OwdG__root",
});
